import {plural, t} from "@lingui/core/macro";
import * as React from "react";
import _ from "underscore";

import type {BadgeCounts as BadgeCountsType} from "#shared-package/profile-model.ts";

const toCategoryName = function (categoryIndex: any) {
    return ["bronze", "silver", "gold", "diamond", "platinum", "master"][
        categoryIndex
    ];
};

type BadgeCountProps = {
    count: number;
    category: number;
};

/**
 * A badge icon and count.
 */
class BadgeCount extends React.Component<BadgeCountProps> {
    render(): React.ReactNode {
        const categoryName = toCategoryName(this.props.category);
        const className =
            "badge-img-small badge-" + categoryName + "-img-small";
        return (
            <span className="badge-category" aria-hidden="true">
                <span className={className} />{" "}
                <span className="badge-count">{this.props.count}</span>
            </span>
        );
    }
}

const _totalBadgesText = function (badgeCounts: BadgeCountsType) {
    const sum = function (xs: ReadonlyArray<number>) {
        return _.reduce(
            xs,
            function (s, x) {
                return s + x;
            },
            0,
        );
    };
    const total = sum(badgeCounts);
    let totalText = plural(total, {
        one: "# badge total.",
        other: "# badges total.",
    });

    if (total > 0) {
        totalText += " ";
    }

    if (total > 150) {
        totalText += t`Legendary!`;
    } else if (total > 100) {
        totalText += t`Wonderful!`;
    } else if (total > 50) {
        totalText += t`Great!`;
    } else if (total > 0) {
        totalText += t`Neato!`;
    }
    return totalText;
};

type Props = {
    counts: BadgeCountsType;
    url: string;
};

/**
 * A series of badge counts in descending order of difficulty.
 */
class BadgeCounts extends React.Component<Props> {
    render(): React.ReactNode {
        const title = _totalBadgesText(this.props.counts);
        const props = {
            className: "profile-badge-count-container visited-no-recolor",
            title: title,
            href: this.props.url,
        } as const;

        const badges = _.map(
            this.props.counts,
            function (count, category) {
                const props = {
                    count: count,
                    category: category,
                    key: category,
                } as const;
                return <BadgeCount {...props} />;
            },
            this,
        ).reverse();

        badges.push(
            <span key="_title" className="sr-only">
                {title}
            </span>,
        );

        return <a {...props}>{badges}</a>;
    }
}

export default BadgeCounts;
